export class ConfigKit {
  adicionalSaboresId: number;
  modalidadeQuantidade: 'FECHADA' | 'ESCOLHIDA_PELO_CLIENTE' = 'FECHADA';
  qtdeMinimaCompra: number;
  qtdeMaximaCompra: number = null;
  incrementoCompra: number;
  qtdeUnidadesReferencia: number;
  qtdeMinimaPorSabor = 1;
  qtdeMaximaDeSabores: number = null;
}
